import * as _4 from 'lodash4';
import { IQuestionAnswerObjectDTD } from './../../../datastore/poll_answer_datastore';
import { IQuestionTypesEnum } from './../../../types/question_types';

export class PollResultsPieComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-poll/src/components/results/poll_results_pie/poll_results_pie.html';
  public controller: any = 'PollResultsPieController';
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    question: '<'
  };
}

export class PollResultsPieController {
  private _tertiary_color_array: string[] = [
    '#007FAA',
    '#DB0A5B',
    '#3B853B',
    '#802200',
    '#098387',
    '#9459D4',
    '#B02779',
    '#003366',
    '#8F10A2',
    '#B36200',
    '#D43900',
    '#B36200'
  ];

  private pie_tertiary_color_array: string[];
  private showResults: boolean;
  private question: IQuestionAnswerObjectDTD;

  constructor(private QuestionTypesEnum: IQuestionTypesEnum) {}

  $onInit(): void {
    this.update();
  }

  $onChanges(changes: ng.IChangesObject): void {
    this.update();
  }

  update(): void {
    if (_4.isEmpty(this.question)) {
      return;
    }

    _4.forEach(this.question._active_choices, (choice: any, index: number) => {
      choice.colorIndex = index;
    });

    this.question.choice_values = _4.toArray(_4.mapValues(this.question._active_choices, 'answered_percent'));
    this.showResults =
      !this.QuestionTypesEnum.isFreeText(this.question.question_type) || !_4.isNumber(this.question.choice_values);

    const resultLen = this.question.choice_values.length;

    if (resultLen <= this._tertiary_color_array.length) {
      this.pie_tertiary_color_array = this._tertiary_color_array.slice(0, this.question.choice_values.length);
    } else {
      const finishColorArrayThisManyTimes = Math.floor(resultLen / this._tertiary_color_array.length);
      const leftOverColors = resultLen % this._tertiary_color_array.length;
      const combinedArrayOfColors = _4.flatten(
        _4.times(finishColorArrayThisManyTimes, () => this._tertiary_color_array)
      );

      this.pie_tertiary_color_array = _4.concat(
        combinedArrayOfColors,
        this._tertiary_color_array.slice(0, leftOverColors)
      );
    }
  }

  colorString(index: number): string {
    return `color: ${this._tertiary_color_array[index % this._tertiary_color_array.length]}`;
  }

  answerCollectionText(): string {
    if (this.QuestionTypesEnum.isMultiple(this.question.question_type)) {
      return `We have ${this.question.total_answers} responses so far.`;
    }

    return `${this.question.total_answers} students have answered this so far.`;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/components/results/poll_results_pie/poll_results_pie_controller.ts